// extracted by mini-css-extract-plugin
export default {"header":"CompositionsPage_header__8AyQk"};